import React from 'react';
import PropTypes from 'prop-types';
import musanedLogo from 'assets/img/musaned-logo.svg';

const BrandMark = ({ height, className, style }) => (
  <img
    src={musanedLogo}
    alt="مساند"
    className={className}
    style={{
      height,
      width: 'auto',
      display: 'block',
      maxWidth: '100%',
      ...style,
    }}
  />
);

BrandMark.propTypes = {
  className: PropTypes.string,
  height: PropTypes.number,
  style: PropTypes.object,
};

BrandMark.defaultProps = {
  height: 40,
  className: '',
  style: undefined,
};

export default BrandMark;
